module.exports = __webpack_public_path__ + "static/CreateBugTask-36ef3e41a3c4da6c628df0180ee5b28b.png";